module.exports = __webpack_public_path__ + "img/4Y5.c46ceeb8.png";